import interviewAnalyticsReducer from "./Interviews/reducer";
import DailyInterviewsReducer from "./DailyInterviews/reducer";
import InterviewFormReducer from "./InterviewForm/reducer";
export {
  interviewAnalyticsReducer,
  DailyInterviewsReducer,
  InterviewFormReducer,
};
